import { Text, useToast } from '@chakra-ui/react';
import React from 'react';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';
import { localise, templateReplace } from '../../../services/lang/lang';
import { getGetInspectionDetailQueryKey, useDeleteFinding, } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { queryClient } from '../../../services/api/query/queryClient';
export const DeleteFindingModal = ({ finding, onClose, onFindingMutated, onDeleted, }) => {
    const toast = useToast();
    const { mutate, isPending, isError, error } = useDeleteFinding();
    const onDelete = () => {
        mutate({ id: finding.id }, {
            onSuccess: (response) => {
                onDeleted();
                onFindingMutated(finding);
                toast({
                    title: localise('FINDING_DELETED'),
                    status: 'success',
                });
                const data = unwrapModel(response);
                if (!data)
                    return;
                if (data.was_last_finding) {
                    queryClient.invalidateQueries({
                        queryKey: ['/api/v1/inspections/listing'],
                    });
                    queryClient.invalidateQueries({
                        queryKey: getGetInspectionDetailQueryKey(finding.location.inspection_id),
                    });
                }
            },
        });
    };
    return (React.createElement(ConfirmationModal, { isOpen: true, onClose: onClose, onConfirm: onDelete, title: localise('DELETE_FINDING'), isLoading: isPending, isError: isError, confirmText: localise('DELETE_CHALLENGE'), error: error },
        React.createElement(Text, { "data-testid": "delete_finding_modal__text", variant: "md-600-rg-3" }, templateReplace(localise('DELETE_FINDING_CONFIRM_QUESTION'), {
            reference: finding.reference,
        }))));
};
